import { render, staticRenderFns } from "./BaleDetailRow.vue?vue&type=template&id=6a2f95d0&scoped=true"
import script from "./BaleDetailRow.vue?vue&type=script&lang=js"
export * from "./BaleDetailRow.vue?vue&type=script&lang=js"
import style0 from "./BaleDetailRow.vue?vue&type=style&index=0&id=6a2f95d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2f95d0",
  null
  
)

export default component.exports